<script>
	export let btnClass;
	export let initPage;
	export let room;
	export let ws;
	export let SocketClient;
	export let socketAddr;
	export let gameAlert = function(msg) {
		alert(msg);
	};
	
	//참가시 상위 코드 호출 
	let roomId = '';
	
	$: verifiedID = roomId.trim().length && roomId.trim().length <= 200 && !roomId.includes('%');
	
	const join = function(e) {
		if (e && e.type === 'keypress' && e.which !== 13) {
			return;
		}
		if (!verifiedID) {
			gameAlert(`방 ID 앞, 뒤로 공백이 없이 200자 이내로 <b>%</b> 기호를 제외하고 입력하여 주십시오.`);
			return;
		}
		roomId = roomId.trim();
		room.id = roomId.trim();
		
		ws = new SocketClient(socketAddr);
		ws.connect();
		ws.socket.addCallback('error', (type, msg) => {
			if (type.startsWith('ROOM')) {
				cancel();
			}
		});
		ws.socket.join(roomId, '');
		room.gameStatus = 'join';
	}
	
	/**
	 * 참가 취소
	 */
	const cancel = function() {
		if (ws instanceof SocketClient) {
			ws.disconnect();
		}
		room.players = 1;
		room.gameStatus = 'wait';
		roomId = '';
	}
</script>

<!-- S : PAGE[2] - 방 참가 -->
<div class="game-modal-wrap" class:on={btnClass.attend} data-modal="attend">
	{#if room.gameStatus === 'wait'}
	<div class="modal attend">
		<dl class="game-list">
			<div class="group">
				<dt><label for="input-id-share">방 ID</label></dt>
				<dd><input type="text" id="input-id-share" placeholder="공유받은 방 ID를 입력하세요" bind:value={roomId} on:keypress={join}></dd>
			</div>
		</dl>
		<div class="btn-wrap">
			<button type="button" class="info">대기중... <strong>{room.players}/6명</strong></button>
			<div class="group">
				<button type="button" class="btn" on:click={join}>참가</button>
				<button type="button" class="btn gray-border" on:click={()=> { roomId = '' ; initPage()}}>취소</button>
			</div>
		</div>
	</div>
	{:else}
	<div class="modal start">
		<div class="txt-box">
			<p class="title">참가 중...</p>
			<p class="desc">방 ID : <b>{room.id}</b><br><br>매칭 참가자를 기다리는 중 입니다</p>
		</div>
		<div class="btn-wrap">
			<div class="info">대기중... <strong>{room.players}/6명</strong></div>
			<button type="button" class="btn gray-border" on:click={cancel}>취소</button>
		</div>
	</div>
	{/if}
</div>
<!-- E : PAGE[2] - 방 참가 -->

<style lang="scss">
</style>